<template>
  <div id="app">
    <navbar v-show="isNavbarShow"></navbar>
    <!-- <router-view  /> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <footers v-show="isFooterShow"></footers>
  </div>
</template>
<script>
import navbar from './components/Navbar'
import footers from './components/Footer'
import { mapState } from 'vuex'
import axios from "axios";

export default {
  components: {
    navbar,
    footers
  },
  computed: {
    ...mapState(['isFooterShow', 'isNavbarShow'])
  },
  mounted () {
    document.documentElement.scrollTop = 0
    this.$store.state.value = "";
    sessionStorage.removeItem("goodsName");
    // this.getShoppingNumber();
  },
  methods: {
    getShoppingNumber () {
      // console.log("app getShoppingNumber")
      axios.get(`${this.APi}/api/v1/shopping/query/shoppingTrolleyCount`, {
        headers: { token: localStorage.getItem("token") }
      }).then(res => {
        if (res.data.code == "200") {
          this.$store.state.count = res.data.result;
          this.$store.state.code = "";
          localStorage.setItem("code", "");
        }
        if (res.data.code == "1001") {
          this.$store.state.code = "1";
          localStorage.setItem("code", "1");
        }
      });
    }
  }
}
</script>

<style lang="scss">
// 1rem === 80px
body,
h1,
h2,
h3,
h4,
h5,
h6,
p,
a,
img,
input,
ul,
ol,
dl,
dt,
dd,
li,
figure,
figcaption {
  padding: 0;
  margin: 0;
}
ul,
ol {
  list-style: none;
}
img {
  display: block;
  border: 0;
}
input,
select {
  outline: none;
}
header,
footer,
nav,
section,
figure,
figcaption,
main,
article,
aside {
  display: block;
}
html,
body {
  font-family: Arial, sans-serif;
}
html {
  font-size: 100 / (1920 / 100) vw;
}
body {
  font-size: 0.2rem !important;
  color: #a09e9c;
  background: #fff;
  margin: 0 auto;
  overflow-x: hidden;
  font-family: Arial, sans-serif !important;
}

a {
  text-decoration: none;
  color: #a09e9c;
}

.ws {
  width: 14.25rem;
  margin: 0 auto;
}

.l {
  float: left;
}
.r {
  float: right;
}
.clear {
  margin: 0px auto;
  clear: both;
  height: 0px;
  font-size: 0px;
  overflow: hidden;
}
</style>
